import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import GlobalSourceManagement from '../../components/templates/admin/GlobalSourceManagement';

const GlobalSourceManagementPage = () => {
  return (
    <AdminLayout>
      <GlobalSourceManagement />
    </AdminLayout>
  );
};

export default GlobalSourceManagementPage;
